import React, { useState } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import "./Competitor.css";
import Img from "react-image";
import DeleteModal from "../../Common/Modal/DeleteModal/DeleteModal";
import Utils from "../../../Utils/Utils";
import { imageConstants, colorConstants } from "../../../config/constants";
import { sortBy } from "lodash";

let selectedValue = {};
const { translate } = Utils;

const CompetitorModal = ({
  showModal,
  handleClose,
  selectedItem,
  saveCompetitor,
  updateCompetitor,
  getCompetitorsData,
  competitorsData,
}) => {
  const nameRef = React.createRef();
  const [error, setError] = React.useState(false);
  const [duplicateError, setDuplicateError] = React.useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setError(false);
    setDuplicateError(false);

    const enteredName = nameRef.current.value.trim().toLowerCase();

    const nameExists = competitorsData?.some(
      (competitor) =>
        competitor.retailerName.toLowerCase() === enteredName &&
        competitor.retailerId !== selectedItem?.retailerId
    );

    if (nameExists) {
      setDuplicateError(true);
      return;
    }

    const payload = { retailerName: nameRef.current.value };
    const onDone = (status) => {
      if (status) {
        getCompetitorsData();
        handleClose();
      } else {
        setError(true);
      }
    };
    if (selectedItem) {
      updateCompetitor(selectedItem.retailerId, payload, onDone);
    } else {
      saveCompetitor(payload, onDone);
    }
  };

  const onModalClose = () => {
    setError(false);
    setDuplicateError(false);
    handleClose();
  };

  return (
    <Modal
      dialogClassName="my-modal"
      show={showModal}
      onHide={onModalClose}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="modal-header" closeButton>
        <Modal.Title className="header">
          {selectedItem ? translate.EditCompetitor : translate.AddCompetitor}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group as={Row} controlId="competitorName">
            <Form.Label column sm={3}>
              {translate.CompetitorName}
            </Form.Label>
            <Col sm={9}>
              <Form.Control
                style={{ width: "90%", height: 50 }}
                required
                ref={nameRef}
                defaultValue={selectedItem?.retailerName || ""}
                type="text"
                placeholder={translate.CompetitorName}
              />
              {error && (
                <p
                  style={{
                    fontSize: 14,
                    color: colorConstants.redColor,
                    paddingTop: 10,
                  }}
                >
                  {translate.errorMessage}
                </p>
              )}
              {duplicateError && (
                <p
                  style={{
                    fontSize: 14,
                    color: colorConstants.redColor,
                    paddingTop: 10,
                  }}
                >
                  {translate.CompetitorExists}
                </p>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} style={{ paddingTop: 10 }}>
            <Form.Label column sm={2} />
            <Col sm={2}>
              <Button
                type="submit"
                className="btn save-store"
                style={{
                  width: 100,
                  fontWeight: "bold",
                  backgroundColor: colorConstants.themeColor,
                }}
              >
                {translate.saveText}
              </Button>
            </Col>
            <Col sm={2} style={{ paddingLeft: 40 }}>
              <Button
                onClick={onModalClose}
                style={{
                  width: 100,
                  fontWeight: "bold",
                  backgroundColor: colorConstants.whiteColor,
                }}
              >
                <span style={{ color: colorConstants.themeColor }}>
                  {translate.cancelText}
                </span>
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

const Competitor = (props) => {
  const [show, setShow] = useState(false);
  const [deleteModalFlag, setDeleteModal] = useState(false);
  const [deleteError, setDeleteError] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleDeleteShow = () => setDeleteModal(true);
  const handleDeleteClose = () => {
    setDeleteModal(false);
    setDeleteError(false);
  };

  return (
    <div className="bottom-div">
      <div className="d-flex flex-row justify-content-between">
        <p className="custom-store">{translate.Competitor}</p>
        <div>
          <Button
            className="btn add-store"
            onClick={() => {
              handleShow();
              selectedValue = false;
            }}
          >
            <Img
              style={{
                width: 25,
                height: 24,
                marginRight: 10,
              }}
              src={imageConstants.buttonIcon}
            />
            <span className="custom-class">{translate.AddCompetitor}</span>
          </Button>
        </div>
      </div>
      <CompetitorModal
        showModal={show}
        handleClose={handleClose}
        selectedItem={selectedValue || null}
        saveCompetitor={props.saveCompetitor}
        updateCompetitor={props.updateCompetitor}
        getCompetitorsData={props.getCompetitorsData}
        competitorsData={props.competitorsData}
      />
      <DeleteModal
        showModal={deleteModalFlag}
        handleClose={handleDeleteClose}
        deleteError={deleteError}
        confirmDelete={() => {
          props.deleteCompetitor(
            selectedValue.retailerId,
            (status, response) => {
              if (status) {
                props.getCompetitorsData();
                handleDeleteClose();
              } else if (response?.status === 409) {
                setDeleteError(true);
              }
            }
          );
        }}
      />
      <table className="table table-borderless custom-table">
        <thead>
          <tr>
            <th scope="col">{translate.SerialNumberText}</th>
            <th scope="col" className="w-88">
              {translate.CompetitorName}
            </th>
            <th scope="col">{translate.actionText}</th>
          </tr>
        </thead>
        <tbody>
          {props.competitorsData &&
            sortBy(props.competitorsData, "retailerId").map((item, index) => {
              return (
                <tr
                  key={index}
                  className="shadow-sm rounded bg-white custom-border ml-1 mr-2 p-1 mb-2"
                >
                  <td>{index + 1}</td>
                  <td style={{ textTransform: "capitalize", minWidth: 200 }}>
                    {item.retailerName}
                  </td>
                  <td className="action-css">
                    <div
                      className="Rounded-Rectangle-14 rounded cursor"
                      onClick={() => {
                        handleShow();
                        selectedValue = item;
                      }}
                    >
                      <Img
                        decode={false}
                        src={imageConstants.editIcon}
                        className="Forma-1"
                      />
                    </div>
                    <div
                      className="Rounded-Rectangle-14-delete rounded cursor"
                      onClick={() => {
                        handleDeleteShow();
                        selectedValue = item;
                      }}
                    >
                      <Img
                        decode={false}
                        src={imageConstants.deleteIcon}
                        className="Forma-1-delete "
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default Competitor;
